import type { PostSiretVerifyResponse } from "@/app/api/cat/siret-verify/route";
import { useMutation } from "@tanstack/react-query";

const ENDPOINT = "/api/cat/siret-verify";

export type CatSiretVerifyInput = {
  mdmBrandCode?: string | null;
  siret: string;
};

export function useCatSiretVerifyMutation() {
  return useMutation({
    mutationFn: async ({ mdmBrandCode, siret }: CatSiretVerifyInput) => {
      const response = await fetch(ENDPOINT, {
        body: JSON.stringify({
          mdmBrandCode: mdmBrandCode ?? undefined,
          siret,
        }),
        headers: { "Content-Type": "application/json" },
        method: "POST",
      });

      if (response.status === 401) {
        throw new Error("Unauthorized");
      }

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "Client error");
      }

      return response.json() as Promise<PostSiretVerifyResponse>;
    },
  });
}
